import React from "react";
import { Alert } from "@material-ui/lab";
import { Box, Typography } from "@material-ui/core";

const Message = ({ message }) => {
  if (!message) return null;

  return (
    <Box my={2} align="start" style={{ width: "100%" }}>
      <Alert severity="error">
        <Typography variant="body1" style={{ whiteSpace: "pre-wrap" }}>
          {message}
        </Typography>
      </Alert>
    </Box>
  );
};

export default Message;
